var _excluded = ["children", "className", "inViewIndex", "selectedIndex"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useState, useLayoutEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("./tablist.css");
var styles = {
  "tablistWrapper": "tablistWrapper-1I3Wi",
  "tabSpacer": "tabSpacer-3XivU",
  "tabButton": "tabButton-pNDJp",
  "tabButtonActive": "tabButtonActive-2_a7R"
};
import TabScroller from '../tabscroller';
var Tablist = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      className,
      inViewIndex,
      selectedIndex
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var tabpanelRefs = [];
  var [cssContent, setCssContent] = useState([]);
  var setDataCssContentAttribute = useCallback(() => {
    tabpanelRefs.forEach((panel, index) => {
      if (panel.innerText) {
        if (!cssContent[index]) {
          return setCssContent(prevArray => [...prevArray, panel.innerText]);
        }
        if (cssContent[index] !== panel.innerText) {
          var newArray = [...cssContent];
          newArray[index] = panel.innerText;
          return setCssContent(newArray);
        }
      }
      return null;
    });
  }, [cssContent, tabpanelRefs]);
  useLayoutEffect(() => {
    return setDataCssContentAttribute();
  }, [setDataCssContentAttribute]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tablistWrapper
  }, /*#__PURE__*/React.createElement(TabScroller, _extends({
    inViewIndex: selectedIndex,
    ref: ref
  }, otherProps), React.Children.map(children, (child, index) => {
    if (!child) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: index === 0 ? null : styles.tabSpacer
    }, /*#__PURE__*/React.cloneElement(child, {
      className: cs(styles.tabButton, {
        [styles.tabButtonActive]: selectedIndex === index,
        [child.props.className]: !!child.props.className
      }),
      'data-css-content': cssContent === null || cssContent === void 0 ? void 0 : cssContent[index],
      ref: el => {
        tabpanelRefs[index] = el;
        if (child.ref) child.ref(el);
      }
    }));
  })));
});
Tablist.propTypes = {
  /** Children to be rendered in the tablist - should be links or buttons. */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Index of a tab that should be scrolled into view - should be either selected tab or tab with focus. */
  inViewIndex: PropTypes.number,
  /** Index of the tab to be shown in a selected state. */
  selectedIndex: PropTypes.number
};
Tablist.defaultProps = {
  className: '',
  inViewIndex: 0,
  selectedIndex: 0
};
export default Tablist;